export default __webpack_public_path__ + "static/media/mercy-intro.111280f6.mp3";